module.exports = __webpack_public_path__ + "af1473fa04952b785659d5fbd9e7e3c1.png";